import axios from "axios";

export const loadAllSolutionsAPI = (payload) => {
  return axios
    .get(
      `${payload.dataURL}?limit=${payload.pageSize}&siteId=${
        payload.siteId
      }&requestId=${payload.requestId}&page=${payload.currentPage}&orderBy=${
        payload.sort ? payload.sort.dir : "desc"
      }&orderColumn=${payload.sort ? payload.sort.column : 0}&search=${
        payload.search ?? ""
      }&status=${payload.statusFilter}&stage="${JSON.stringify(
        payload.stageOptions
      )}"&centreId=${payload.centreId}`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    )
    .then((res) => res.data);
};

export const loadSingleSolutionAPI = (payload) => {
  return axios
    .get(`/solutions/${payload.solutionId}`, {
      headers: {
        Accept: "application/json",
      },
    })
    .then((res) => res.data);
};
